import { makeStyles } from "@fluentui/react-components";
import designTokens from "theme/customTheme";

export const useManageWorkspacesListViewStyles = makeStyles({
  workspaceNameCellExtra: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  truncatedText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
  },

  statusCell: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.medium,
    color: designTokens.neutral[700],
  },
});
